import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SubscribersTab = ({ token }) => {
    const [data, setData] = useState(null);

    useEffect(() => {
        axios
            .get(`${API}/admin/subscribers`, { headers: { Authorization: `Bearer ${token}` } })
            .then((r) => setData(r.data))
            .catch(() => setData({ subscribers: [], count: 0 }));
    }, [token]);

    if (!data) {
        return <p className="text-zinc-500 text-sm" data-testid="admin-subscribers-loading">Loading…</p>;
    }

    return (
        <div data-testid="admin-subscribers-tab">
            <h2 className="font-display font-semibold uppercase tracking-tight text-2xl mb-2">The Blacklist</h2>
            <p className="text-xs text-zinc-500 mb-8" data-testid="admin-subscribers-count">
                {data.count} member{data.count === 1 ? "" : "s"} waiting for Drop 001
            </p>
            <div className="border border-zinc-800 divide-y divide-zinc-800">
                {data.subscribers.map((s, i) => (
                    <div key={s.id || i} className="flex justify-between px-4 py-3 text-sm" data-testid={`admin-subscriber-${i}`}>
                        <span>{s.email}</span>
                        <span className="text-zinc-500 text-xs">{new Date(s.created_at).toLocaleDateString()}</span>
                    </div>
                ))}
                {data.subscribers.length === 0 && (
                    <p className="px-4 py-6 text-sm text-zinc-500">No members yet.</p>
                )}
            </div>
        </div>
    );
};
